// extracted by mini-css-extract-plugin
module.exports = {"label":"boolean_label__Sdq7o font-bold inline-block mr-2","content":"boolean_content__HJn5b inline-block"};